// extracted by mini-css-extract-plugin
module.exports = {"main":"Spacer-module--main--1QRKs","mainAlt":"Spacer-module--mainAlt--16TOJ"};